import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
import { painPoints } from '../data/closing';
export function PainPoints() {
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-88" data-mp="2lp54sq5qh0t5">
      <div className="mx-auto max-w-4xl" data-id="element-89" data-mp="26xmu97vn7yh6">
        <header className="text-center" data-id="element-90" data-mp="26wldqnvuyjs2">
          <h2 className="font-display text-[25px] font-bold sm:text-4xl" data-id="element-91" data-mp="2bwhac22878xl">
            ¿Sentís que llevás demasiada carga emocional y no encontrás cómo aflojar?
          </h2>
          <p className="mt-6 font-semibold text-foreground-muted" data-id="element-92" data-mp="21z32gqudbsgw">
            Cumplís con tus responsabilidades. Seguís adelante con todo.
          </p>
          <p className="mt-2 text-lg font-semibold text-primary-soft" data-id="element-93" data-mp="1o1ekprvll1g2">
            Pero muchas veces, al terminar el día, tu cuerpo sigue cargando tensión.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-94" data-mp="3ie4em9lyuang">
          {painPoints.map(({
          title,
          text
        }, index) => <motion.div key={title} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.25,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-xl border border-danger-border/70 bg-danger-surface p-4 sm:p-5" data-id="element-95" data-mp="3nbwfht4l973s" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-danger" aria-hidden="true" data-id="element-96" data-mp="23trdmb0t3ukv" />
              <p className="text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-97" data-mp="1g3nlp0wzdj9p">
                <span className="font-bold text-foreground" data-id="element-98" data-mp="1b4ssr65auebv">{title}:</span> {text}
              </p>
            </motion.div>)}
        </div>
        <p className="mx-auto mt-10 max-w-3xl text-center font-display text-[22px] font-bold italic text-highlight sm:text-3xl" data-id="element-99" data-mp="1k3o1opzqa2iv">
          ¿Y si tuvieras movimientos sencillos y preparados para acompañar esos momentos sin tener que saber bailar?
        </p>
      </div>
    </section>;
}